import { reduxMiddleware as sentryReduxMiddleware } from '@cancellation-portal/assets/js/sentry';
import { applyMiddleware, createStore } from 'redux';
import type { Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { middleware as reduxPackMiddleware } from 'redux-pack';
import promiseMiddleware from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';
import { rootReducer } from './ducks';

const composeEnhancers = composeWithDevTools({});

export const store = createStore(
  rootReducer,
  undefined,
  composeEnhancers(applyMiddleware(sentryReduxMiddleware(), thunkMiddleware, reduxPackMiddleware, promiseMiddleware()))
) as Store;
